// types of actions to be supported by products (ADS)

export const GET_PRODUCTS_LOADING = "products/loading";
export const GET_PRODUCTS_SUCCESS = "products/success";
export const GET_PRODUCTS_ERROR = "products/error";

// Reset
export const RESET_PRODUCTS = "products/reset";